import React from "react";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";
import { removeSpaces } from "../../common/data";

const ContactInfo = () => {
  const sheet_data = useGeneralSheetHook();

  return (
    <>
      <section className="contact-info">
        <div className="container">
          <div className="row">
            <div className="col-xl-2 col-lg-2"></div>
            <div className="col-xl-5 col-lg-4">
              <div className="contact-info__single">
                <h4 className="contact-info__title">Address</h4>
                <p className="contact-info__text">{sheet_data.address}</p>
              </div>
            </div>
            <div className="col-xl-5 col-lg-4">
              <div className="contact-info__single contact-info__single-3">
                <h4 className="contact-info__title">Contact</h4>
                <p className="contact-info__email-phone">
                  <a
                    href={`mailto:${sheet_data.email}`}
                    className="contact-info__email"
                  >
                    {sheet_data.email}
                  </a>
                  <a
                    href={`tel:${removeSpaces(sheet_data.phone_number_1)}`}
                    className="contact-info__phone"
                  >
                    +{sheet_data.phone_number_1.replace("`", "")}
                  </a>
                  <a
                     href={`tel:${removeSpaces(sheet_data.phone_number_2)}`}
                    className="contact-info__phone"
                  >
                    +{sheet_data.phone_number_2.replace("`", "")}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInfo;
